/*  NavigationLink.js
 *   This component generates anchor tags in a list item for the footer.
 *
 *  Properties & Uses
 *   title - (string) the link title
 *   href - (string) link href
 *   slug - (string) passed from country.slug, slug URL associated with the country
 *   external - (boolean) determines whether the link should open a new tab or not
 *   dark - (boolean) determines if the class 'text-primary' should be added to make the link blue
 *   light - (boolean) determines if the class 'text-secondary' should be added to make the link grey
 */

import * as React from "react"

import { routify } from "../js/routify"

const NavigationLink = props => (
  <li>
    {/* The slug will be appended to the beginning of the href */}
    <a
      target={props.external ? "_blank" : "_self"}
      className="footer-link"
      href={routify(props.countryCode || "JM", props.href)}
      className={
        props.dark ? "text-primary" : props.light ? "text-secondary" : ""
      }
    >
      {props.title}
    </a>
  </li>
)

export default NavigationLink
